<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-title"><a id="page_5">Contents</a></h2><a id="page_5">
</a><p class="toc_fm"><a id="page_5"></a><a href="#/xhtml/05_Foreword">Foreword by Nigel Cave</a></p>
<p class="toc_fm"><a href="#/xhtml/06_Bibliography">Bibliography</a></p>
<p class="toc_chp1t"><a href="#/xhtml/07_chapter01"><span class="tocr"><i>Chapter One</i></span> <b>Battleground Italy: Salerno to Rome</b></a></p>
<p class="toc_chp1"><span href="#/xhtml/08_chapter02" title="Link target outside of Sample"><span class="tocr"><i>Chapter Two</i></span> <b>Battleground Normandy: D-Day to Paris</b></span></p>
<p class="toc_chp"><span href="#/xhtml/09_chapter03" title="Link target outside of Sample"><span class="tocr"><i>Chapter Three</i></span> <b>Operation Valkyrie: Attempt to Kill Hitler</b></span></p>
<p class="toc_chp2"><span href="#/xhtml/10_chapter04" title="Link target outside of Sample"><span class="tocr"><i>Chapter Four</i></span> <b>Hitler’s Revenge: The Flying Bomb and V-2</b></span></p>
<p class="toc_chp3"><span href="#/xhtml/11_chapter05" title="Link target outside of Sample"><span class="tocr"><i>Chapter Five</i></span> <b>Americans Advance in the South Pacific</b></span></p>
<p class="toc_chp4"><span href="#/xhtml/12_chapter06" title="Link target outside of Sample"><span class="tocr"><i>Chapter Six</i></span> <b>Japanese in Burma: Kohima and Imphal</b></span></p>
<p class="toc_chp"><span href="#/xhtml/13_chapter07" title="Link target outside of Sample"><span class="tocr"><i>Chapter Seven</i></span> <b>Hitler Loses His Army Group Centre</b></span></p>
<p class="toc_chp"><span href="#/xhtml/14_chapter08" title="Link target outside of Sample"><span class="tocr"><i>Chapter Eight</i></span> <b>Allied Bomber Offensive: Berlin, Ball Bearings and Oil</b></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?545bc6fd